/*
 *
 * CallUsModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 09-Jan-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CallUsModal from './CallUsModal'
import { doShowPopup, doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ doShowPopup, doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  currentInfo: nullSafe(() => state.CallUs.selected, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(CallUsModal)
